// extracted by mini-css-extract-plugin
export default {"videoEmbed":"j1A3g","player":"c0hr+","thumbnail":"Rcgt1","overlay":"iOf0c","button":"FmzTl","arrow":"u6938","icon":"_8Twf1"};